import { render } from "./HeroiconsSolidTrash.vue?vue&type=template&id=1e3864e8"
const script = {}

import exportComponent from "/home/roland/vscode/yachtbroker/portal/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTrash.vue"]])

export default __exports__